import { Button } from '@montugroup/design-system';
import { styled } from '@mui/material';

import { ManageButton } from './UpcomingConsultationCard.styles';
import { waitlistControlHeight } from './WaitlistPreferenceForm.styles';

// the card's link-style button, at body size and without padding so it lines up with the text around it
export const TextButton = styled(ManageButton)(({ theme }) => ({
  fontSize: theme.typography.body1.fontSize,
  padding: 0,
}));

export const JoinButton = styled(Button)(({ theme }) => ({
  height: waitlistControlHeight(theme),
  alignSelf: 'center',
  [theme.breakpoints.up('sm')]: {
    alignSelf: 'flex-start',
  },
}));
